import { FeaturesResearchFilterModel } from './features-research-filter.model';

export class FeaturesResearchModel {
  constructor(
    public filter?: FeaturesResearchFilterModel
  ) {}
}
